export function isMemberDashboard()
{
    return document.getElementById('siteType').value !== 'b2c';
}
